// values for $sort parameter
const ASCENDING = 1;
const DESCENDING = -1;

const getSortOrder = isDescending => {
  return isDescending ? DESCENDING : ASCENDING;
};

const isSortingMultipleFields = sortByField => {
  return Array.isArray(sortByField);
};

const sortMultipleFields = ({ sortByField, sortOrder }) => {
  const sortParams = {};
  sortByField.forEach(field => { sortParams[field] = sortOrder; });
  return sortParams;
};

// build the query params to pass to a find query in the feathers API
export const buildQueryParams = ({ page, descending, sortByField, limit }) => {
  const sortOrder = getSortOrder(descending);
  let sortParams = { [sortByField]: sortOrder };

  if (isSortingMultipleFields(sortByField)) {
    sortParams = sortMultipleFields({ sortByField, sortOrder });
  }
  return {
    $limit: limit,
    $sort: sortParams,
    $skip: limit * (page - 1),
  };
};

